import { useOAuthConfig as e } from "../OAuthConfigContext.mjs";
import { useLinkOAuthMutation as t } from "../useLinkOAuthMutation.mjs";
import { acquireAppleCredential as n } from "./sdk/appleCredential.mjs";
import { setupGoogleButton as r } from "./sdk/googleButton.mjs";
import { useCallback as i } from "react";
//#region src/web/useOAuthConnect.ts
function a(a = {}) {
	let o = e(), s = a.googleClientId ?? o.googleClientId, c = a.appleClientId ?? o.appleClientId, l = a.appleRedirectURI ?? o.appleRedirectURI, u = t(), { onSuccess: d, onError: f } = a, p = i(async (e) => {
		try {
			await u.mutateAsync(e), d?.();
		} catch (e) {
			f?.(e);
		}
	}, [
		u,
		d,
		f
	]);
	return {
		setupGoogleConnect: i(async (e) => {
			!s || !e || await r({
				clientId: s,
				container: e,
				autoPrompt: !1,
				onCredential: (e, t) => void p({
					provider: "google",
					credential: e,
					nonce: t
				}),
				onError: f
			});
		}, [
			s,
			p,
			f
		]),
		connectApple: i(async () => {
			if (c) try {
				let { credential: e, nonce: t, appleUser: r } = await n({
					clientId: c,
					redirectURI: l
				});
				await p({
					provider: "apple",
					credential: e,
					nonce: t,
					appleUser: r
				});
			} catch (e) {
				if (e?.error === "popup_closed_by_user") return;
				f?.(e);
			}
		}, [
			c,
			l,
			p,
			f
		]),
		googleEnabled: !!s,
		appleEnabled: !!c,
		isPending: u.isPending,
		error: u.error
	};
}
//#endregion
export { a as useOAuthConnect };
